function Footer() {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="row footer-content">
          <div className="col-lg-5 col-md-4 footer-brand-column">
            <p className="footer-label">(Get In Touch)</p>
            <a className="footer-brand" href="#top">
              <img src="/assets/images/logo-black.png" alt="Designs By Arushi" />
            </a>
          </div>

          <div className="col-lg-4 col-md-4 footer-location">
            <p className="footer-label">(Location)</p>
            <address>
              Tower A, Golf Course Road,
              <br />
              Sector - 54 Gurugram,
              <br />
              Haryana - 122011
            </address>
          </div>

          <div className="col-lg-3 col-md-4 footer-contact" id="contact">
            <p className="footer-label">(Contact)</p>
            <a href="mailto:info@designsbyarushi.com">info@designsbyarushi.com</a>
            <a href="tel:+911234567890">+91 1234567890</a>
          </div>
        </div>

        <div className="row footer-bottom">
          <div className="col-md-6">
            <p>© 2026 Designs By Arushi. All Rights Reserved</p>
          </div>
          <div className="col-md-6 footer-legal-links">
            <a href="#privacy">Privacy Policy</a>
            <span aria-hidden="true">|</span>
            <a href="#terms">Terms &amp; Conditions</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
